var map = {
	"./builder/1coverimage": 117,
	"./builder/1coverimage.png": 117,
	"./builder/avatar": 118,
	"./builder/avatar.png": 118,
	"./builder/coverimage": 119,
	"./builder/coverimage.png": 119,
	"./builder/download": 120,
	"./builder/download.png": 120,
	"./builder/empty_search": 121,
	"./builder/empty_search.png": 121,
	"./builder/majaslapa": 122,
	"./builder/majaslapa.png": 122,
	"./builder/majaslapa2": 123,
	"./builder/majaslapa2.png": 123,
	"./builder/placeholder-gray": 58,
	"./builder/placeholder-gray.jpg": 58,
	"./builder/placeholder-gray.webp": 897,
	"./builder/qr_example": 124,
	"./builder/qr_example.jpg": 124,
	"./builder/qr_example2": 125,
	"./builder/qr_example2.jpg": 125,
	"./builder/style": 126,
	"./builder/style.jpg": 126,
	"./builder/webpage": 127,
	"./builder/webpage.png": 127,
	"./crosswords/p1": 128,
	"./crosswords/p1.png": 128,
	"./crosswords/p2": 129,
	"./crosswords/p2.png": 129,
	"./crosswords/p3": 130,
	"./crosswords/p3.png": 130,
	"./crosswords/p4": 131,
	"./crosswords/p4.png": 131,
	"./crosswords/pos1": 132,
	"./crosswords/pos1.png": 132,
	"./crosswords/pos2": 133,
	"./crosswords/pos2.png": 133,
	"./crosswords/pos3": 134,
	"./crosswords/pos3.png": 134,
	"./crosswords/pos4": 135,
	"./crosswords/pos4.png": 135,
	"./dashboard/wedding_styles/beach1": 136,
	"./dashboard/wedding_styles/beach1.jpg": 136,
	"./dashboard/wedding_styles/boho1": 137,
	"./dashboard/wedding_styles/boho1.jpg": 137,
	"./dashboard/wedding_styles/clasic1": 138,
	"./dashboard/wedding_styles/clasic1.jpg": 138,
	"./dashboard/wedding_styles/luxury1": 139,
	"./dashboard/wedding_styles/luxury1.jpg": 139,
	"./dashboard/wedding_styles/rustic1": 140,
	"./dashboard/wedding_styles/rustic1.jpg": 140,
	"./dashcore/bg/gift-back": 141,
	"./dashcore/bg/gift-back.jpg": 141,
	"./dashcore/bg/home-back": 142,
	"./dashcore/bg/home-back.jpg": 142,
	"./dashcore/bg/wedding-back": 143,
	"./dashcore/bg/wedding-back.jpg": 143,
	"./dashcore/logo": 144,
	"./dashcore/logo-light": 145,
	"./dashcore/logo-light.png": 145,
	"./dashcore/logo.png": 144,
	"./email/digi_wed_poster": 146,
	"./email/digi_wed_poster.png": 146,
	"./email/facebook-f": 59,
	"./email/facebook-f.png": 59,
	"./email/facebook-f.svg": 898,
	"./email/facebook2x": 147,
	"./email/facebook2x (copy)": 148,
	"./email/facebook2x (copy).png": 148,
	"./email/facebook2x.png": 147,
	"./email/instagram": 60,
	"./email/instagram.png": 60,
	"./email/instagram.svg": 899,
	"./email/instagram2x": 149,
	"./email/instagram2x (copy)": 150,
	"./email/instagram2x (copy).png": 150,
	"./email/instagram2x.png": 149,
	"./email/logo1": 151,
	"./email/logo1.png": 151,
	"./email/tiktok": 61,
	"./email/tiktok.png": 61,
	"./email/tiktok.svg": 900,
	"./email/youtube": 62,
	"./email/youtube.png": 62,
	"./email/youtube.svg": 901,
	"./favicon": 152,
	"./favicon.png": 152,
	"./galata_680x1150": 153,
	"./galata_680x1150.jpg": 153,
	"./gameover": 154,
	"./gameover.jpg": 154,
	"./games/memory_game/gameover": 155,
	"./games/memory_game/gameover.jpg": 155,
	"./games/memory_game/kazas/0": 156,
	"./games/memory_game/kazas/0.jpg": 156,
	"./games/memory_game/kazas/1": 157,
	"./games/memory_game/kazas/1.jpg": 157,
	"./games/memory_game/kazas/2": 158,
	"./games/memory_game/kazas/2.jpg": 158,
	"./games/memory_game/kazas/3": 159,
	"./games/memory_game/kazas/3.jpg": 159,
	"./games/memory_game/kazas/4": 160,
	"./games/memory_game/kazas/4.jpg": 160,
	"./games/memory_game/kazas/5": 161,
	"./games/memory_game/kazas/5.jpg": 161,
	"./games/memory_game/kazas/6": 162,
	"./games/memory_game/kazas/6.jpg": 162,
	"./games/memory_game/kazas/fronts/10m": 163,
	"./games/memory_game/kazas/fronts/10m.jpg": 163,
	"./games/memory_game/kazas/fronts/1m": 164,
	"./games/memory_game/kazas/fronts/1m.jpg": 164,
	"./games/memory_game/kazas/fronts/2m": 165,
	"./games/memory_game/kazas/fronts/2m.jpg": 165,
	"./games/memory_game/kazas/fronts/3m": 166,
	"./games/memory_game/kazas/fronts/3m.jpg": 166,
	"./games/memory_game/kazas/fronts/4m": 167,
	"./games/memory_game/kazas/fronts/4m.jpg": 167,
	"./games/memory_game/kazas/fronts/5m": 168,
	"./games/memory_game/kazas/fronts/5m.jpg": 168,
	"./games/memory_game/kazas/fronts/6m": 169,
	"./games/memory_game/kazas/fronts/6m.jpg": 169,
	"./games/memory_game/kazas/fronts/7m": 170,
	"./games/memory_game/kazas/fronts/7m.jpg": 170,
	"./games/memory_game/kazas/fronts/8m": 171,
	"./games/memory_game/kazas/fronts/8m.jpg": 171,
	"./games/memory_game/kazas/fronts/9m": 172,
	"./games/memory_game/kazas/fronts/9m.jpg": 172,
	"./games/memory_game/meemo/0": 173,
	"./games/memory_game/meemo/0.jpg": 173,
	"./games/memory_game/meemo/1": 174,
	"./games/memory_game/meemo/1.jpg": 174,
	"./games/memory_game/meemo/2": 175,
	"./games/memory_game/meemo/2.jpg": 175,
	"./games/memory_game/meemo/3": 176,
	"./games/memory_game/meemo/3.jpg": 176,
	"./games/memory_game/meemo/4": 177,
	"./games/memory_game/meemo/4.jpg": 177,
	"./games/memory_game/meemo/5": 178,
	"./games/memory_game/meemo/5.jpg": 178,
	"./games/memory_game/meemo/6": 179,
	"./games/memory_game/meemo/6.jpg": 179,
	"./games/memory_game/meemo/fronts/m1": 180,
	"./games/memory_game/meemo/fronts/m1.png": 180,
	"./games/memory_game/meemo/fronts/m10": 181,
	"./games/memory_game/meemo/fronts/m10.png": 181,
	"./games/memory_game/meemo/fronts/m2": 182,
	"./games/memory_game/meemo/fronts/m2.png": 182,
	"./games/memory_game/meemo/fronts/m3": 183,
	"./games/memory_game/meemo/fronts/m3.png": 183,
	"./games/memory_game/meemo/fronts/m4": 184,
	"./games/memory_game/meemo/fronts/m4.png": 184,
	"./games/memory_game/meemo/fronts/m5": 185,
	"./games/memory_game/meemo/fronts/m5.png": 185,
	"./games/memory_game/meemo/fronts/m6": 186,
	"./games/memory_game/meemo/fronts/m6.png": 186,
	"./games/memory_game/meemo/fronts/m7": 187,
	"./games/memory_game/meemo/fronts/m7.png": 187,
	"./games/memory_game/meemo/fronts/m8": 188,
	"./games/memory_game/meemo/fronts/m8.png": 188,
	"./games/memory_game/meemo/fronts/m9": 189,
	"./games/memory_game/meemo/fronts/m9.png": 189,
	"./global/guests": 190,
	"./global/guests (copy)": 191,
	"./global/guests (copy).png": 191,
	"./global/guests.png": 190,
	"./global/wedding-intro": 192,
	"./global/wedding-intro.jpg": 192,
	"./home/1": 193,
	"./home/1.png": 193,
	"./home/4": 194,
	"./home/4.png": 194,
	"./home/about_us/AV0_4653": 195,
	"./home/about_us/AV0_4653.jpg": 195,
	"./home/about_us/AV0_5469": 196,
	"./home/about_us/AV0_5469.jpg": 196,
	"./home/about_us/mes": 197,
	"./home/about_us/mes (copy)": 198,
	"./home/about_us/mes (copy).jpg": 198,
	"./home/about_us/mes.jpg": 197,
	"./home/about_us/peteris_un_sandra_1": 199,
	"./home/about_us/peteris_un_sandra_1.jpg": 199,
	"./home/about_us/velme_atskirties": 200,
	"./home/about_us/velme_atskirties (copy)": 201,
	"./home/about_us/velme_atskirties (copy).jpg": 201,
	"./home/about_us/velme_atskirties.jpg": 200,
	"./home/demo_left": 202,
	"./home/demo_left.png": 202,
	"./home/demo_left2": 203,
	"./home/demo_left2.png": 203,
	"./home/demo_right": 204,
	"./home/demo_right.png": 204,
	"./home/demo_right2": 205,
	"./home/demo_right2.png": 205,
	"./home/left_demo": 206,
	"./home/left_demo.png": 206,
	"./home/logo1": 207,
	"./home/logo1.png": 207,
	"./home/logo1_small": 208,
	"./home/logo1_small.png": 208,
	"./home/logo1_small2": 209,
	"./home/logo1_small2.png": 209,
	"./home/logo2": 210,
	"./home/logo2.png": 210,
	"./home/logo2_small": 211,
	"./home/logo2_small.png": 211,
	"./home/logo3": 212,
	"./home/logo3.png": 212,
	"./home/logo3_small": 213,
	"./home/logo3_small.png": 213,
	"./home/main/aa/1": 214,
	"./home/main/aa/1.png": 214,
	"./home/main/aa/10": 215,
	"./home/main/aa/10.png": 215,
	"./home/main/aa/11": 216,
	"./home/main/aa/11.png": 216,
	"./home/main/aa/12": 217,
	"./home/main/aa/12.png": 217,
	"./home/main/aa/13": 218,
	"./home/main/aa/13.png": 218,
	"./home/main/aa/14": 219,
	"./home/main/aa/14.png": 219,
	"./home/main/aa/15": 220,
	"./home/main/aa/15.png": 220,
	"./home/main/aa/2": 221,
	"./home/main/aa/2.png": 221,
	"./home/main/aa/3": 222,
	"./home/main/aa/3.png": 222,
	"./home/main/aa/4": 223,
	"./home/main/aa/4.png": 223,
	"./home/main/aa/5": 224,
	"./home/main/aa/5.png": 224,
	"./home/main/aa/6": 225,
	"./home/main/aa/6.png": 225,
	"./home/main/aa/7": 226,
	"./home/main/aa/7.png": 226,
	"./home/main/aa/8": 227,
	"./home/main/aa/8.png": 227,
	"./home/main/aa/9": 228,
	"./home/main/aa/9.png": 228,
	"./home/main/aa/backup/1": 229,
	"./home/main/aa/backup/1.png": 229,
	"./home/main/aa/backup/10": 230,
	"./home/main/aa/backup/10.png": 230,
	"./home/main/aa/backup/11": 231,
	"./home/main/aa/backup/11.png": 231,
	"./home/main/aa/backup/12": 232,
	"./home/main/aa/backup/12.png": 232,
	"./home/main/aa/backup/13": 233,
	"./home/main/aa/backup/13.png": 233,
	"./home/main/aa/backup/14": 234,
	"./home/main/aa/backup/14.png": 234,
	"./home/main/aa/backup/15": 235,
	"./home/main/aa/backup/15.png": 235,
	"./home/main/aa/backup/2": 236,
	"./home/main/aa/backup/2.png": 236,
	"./home/main/aa/backup/3": 237,
	"./home/main/aa/backup/3.png": 237,
	"./home/main/aa/backup/4": 238,
	"./home/main/aa/backup/4.png": 238,
	"./home/main/aa/backup/5": 239,
	"./home/main/aa/backup/5.png": 239,
	"./home/main/aa/backup/6": 240,
	"./home/main/aa/backup/6.png": 240,
	"./home/main/aa/backup/7": 241,
	"./home/main/aa/backup/7.png": 241,
	"./home/main/aa/backup/8": 242,
	"./home/main/aa/backup/8.png": 242,
	"./home/main/aa/backup/9": 243,
	"./home/main/aa/backup/9.png": 243,
	"./home/main/aa/dashboard": 244,
	"./home/main/aa/dashboard.png": 244,
	"./home/main/aa/localhost_3000_pages_my_plan (1) (copy)": 245,
	"./home/main/aa/localhost_3000_pages_my_plan (1) (copy).png": 245,
	"./home/main/aa/pakalpojumu_sniedzeji": 246,
	"./home/main/aa/pakalpojumu_sniedzeji.png": 246,
	"./home/main/aa/uzdevumi": 247,
	"./home/main/aa/uzdevumi.png": 247,
	"./home/main/aa/vendors2": 248,
	"./home/main/aa/vendors2.png": 248,
	"./home/main/aa/viesi": 249,
	"./home/main/aa/viesi.png": 249,
	"./home/main/albums": 250,
	"./home/main/albums.png": 250,
	"./home/main/albums_real": 251,
	"./home/main/albums_real.png": 251,
	"./home/main/buj": 252,
	"./home/main/buj.png": 252,
	"./home/main/programma": 253,
	"./home/main/programma.png": 253,
	"./home/main/sakumlapa": 254,
	"./home/main/sakumlapa.png": 254,
	"./home/main/sakums_real": 255,
	"./home/main/sakums_real.png": 255,
	"./home/main/screen1": 256,
	"./home/main/screen1.png": 256,
	"./home/main/spele": 257,
	"./home/main/spele.png": 257,
	"./home/main/temas": 258,
	"./home/main/temas.png": 258,
	"./home/main/uzdevumi": 259,
	"./home/main/uzdevumi.png": 259,
	"./home/main/viesi": 260,
	"./home/main/viesi.png": 260,
	"./home/mini/1": 261,
	"./home/mini/1.png": 261,
	"./home/mini/2": 262,
	"./home/mini/2.png": 262,
	"./home/mini/3": 263,
	"./home/mini/3.png": 263,
	"./home/mini/4": 264,
	"./home/mini/4.png": 264,
	"./home/mini/5": 265,
	"./home/mini/5.png": 265,
	"./home/mini/6": 266,
	"./home/mini/6.png": 266,
	"./home/mini/sc1": 267,
	"./home/mini/sc1.png": 267,
	"./home/mini/sc2": 268,
	"./home/mini/sc2.png": 268,
	"./home/mini/sc3": 269,
	"./home/mini/sc3.png": 269,
	"./home/mini/sc4": 270,
	"./home/mini/sc4.png": 270,
	"./home/mini/screen_1": 271,
	"./home/mini/screen_1.png": 271,
	"./home/mini/screen_10": 272,
	"./home/mini/screen_10.png": 272,
	"./home/mini/screen_11": 273,
	"./home/mini/screen_11.png": 273,
	"./home/mini/screen_12": 274,
	"./home/mini/screen_12.png": 274,
	"./home/mini/screen_2": 275,
	"./home/mini/screen_2.png": 275,
	"./home/mini/screen_4": 276,
	"./home/mini/screen_4.png": 276,
	"./home/mini/screen_9": 277,
	"./home/mini/screen_9.png": 277,
	"./home/right_demo": 278,
	"./home/right_demo.png": 278,
	"./home/sc1": 279,
	"./home/sc1.webp": 279,
	"./home/sc2": 280,
	"./home/sc2.webp": 280,
	"./home/sc3": 281,
	"./home/sc3.webp": 281,
	"./home/sc4": 282,
	"./home/sc4.webp": 282,
	"./home/screen_1": 283,
	"./home/screen_1.png": 283,
	"./home/screen_10": 284,
	"./home/screen_10.png": 284,
	"./home/screen_11": 285,
	"./home/screen_11.png": 285,
	"./home/screen_12": 286,
	"./home/screen_12.png": 286,
	"./home/screen_13": 287,
	"./home/screen_13.png": 287,
	"./home/screen_2": 288,
	"./home/screen_2.png": 288,
	"./home/screen_4": 289,
	"./home/screen_4.png": 289,
	"./home/screen_5": 290,
	"./home/screen_5.png": 290,
	"./home/screen_68": 291,
	"./home/screen_68.png": 291,
	"./home/screen_mobile": 292,
	"./home/screen_mobile.png": 292,
	"./home/screen_pc": 293,
	"./home/screen_pc.png": 293,
	"./home/steps/almost_married": 294,
	"./home/steps/almost_married.png": 294,
	"./home/steps/already_planing": 295,
	"./home/steps/already_planing.png": 295,
	"./home/steps/newly_engaged": 296,
	"./home/steps/newly_engaged.png": 296,
	"./icons/SVG/001": 297,
	"./icons/SVG/001.svg": 297,
	"./icons/SVG/002": 298,
	"./icons/SVG/002.svg": 298,
	"./icons/SVG/003": 299,
	"./icons/SVG/003.svg": 299,
	"./icons/SVG/004": 300,
	"./icons/SVG/004.svg": 300,
	"./icons/SVG/005": 301,
	"./icons/SVG/005.svg": 301,
	"./icons/SVG/006": 302,
	"./icons/SVG/006.svg": 302,
	"./icons/SVG/007": 303,
	"./icons/SVG/007.svg": 303,
	"./icons/SVG/008": 304,
	"./icons/SVG/008.svg": 304,
	"./icons/SVG/009": 305,
	"./icons/SVG/009.svg": 305,
	"./icons/SVG/010": 306,
	"./icons/SVG/010.svg": 306,
	"./icons/SVG/011": 307,
	"./icons/SVG/011.svg": 307,
	"./icons/SVG/012": 308,
	"./icons/SVG/012.svg": 308,
	"./icons/SVG/013": 309,
	"./icons/SVG/013.svg": 309,
	"./icons/SVG/014": 310,
	"./icons/SVG/014.svg": 310,
	"./icons/SVG/015": 311,
	"./icons/SVG/015.svg": 311,
	"./icons/SVG/016": 312,
	"./icons/SVG/016.svg": 312,
	"./icons/SVG/017": 313,
	"./icons/SVG/017.svg": 313,
	"./icons/SVG/018": 314,
	"./icons/SVG/018.svg": 314,
	"./icons/SVG/019": 315,
	"./icons/SVG/019.svg": 315,
	"./icons/SVG/020": 316,
	"./icons/SVG/020.svg": 316,
	"./icons/SVG/021": 317,
	"./icons/SVG/021.svg": 317,
	"./icons/SVG/022": 318,
	"./icons/SVG/022.svg": 318,
	"./icons/SVG/023": 319,
	"./icons/SVG/023.svg": 319,
	"./icons/SVG/024": 320,
	"./icons/SVG/024.svg": 320,
	"./icons/SVG/025": 321,
	"./icons/SVG/025.svg": 321,
	"./icons/SVG/026": 322,
	"./icons/SVG/026.svg": 322,
	"./icons/SVG/027": 323,
	"./icons/SVG/027.svg": 323,
	"./icons/SVG/028": 324,
	"./icons/SVG/028.svg": 324,
	"./icons/SVG/029": 325,
	"./icons/SVG/029.svg": 325,
	"./icons/SVG/030": 326,
	"./icons/SVG/030.svg": 326,
	"./icons/SVG/031": 327,
	"./icons/SVG/031.svg": 327,
	"./icons/SVG/032": 328,
	"./icons/SVG/032.svg": 328,
	"./icons/SVG/033": 329,
	"./icons/SVG/033.svg": 329,
	"./icons/SVG/034": 330,
	"./icons/SVG/034.svg": 330,
	"./icons/SVG/035": 331,
	"./icons/SVG/035.svg": 331,
	"./icons/SVG/036": 332,
	"./icons/SVG/036.svg": 332,
	"./icons/SVG/037": 333,
	"./icons/SVG/037.svg": 333,
	"./icons/SVG/038": 334,
	"./icons/SVG/038.svg": 334,
	"./icons/SVG/039": 335,
	"./icons/SVG/039.svg": 335,
	"./icons/SVG/040": 336,
	"./icons/SVG/040.svg": 336,
	"./icons/SVG/041": 337,
	"./icons/SVG/041.svg": 337,
	"./icons/SVG/042": 338,
	"./icons/SVG/042.svg": 338,
	"./icons/SVG/043": 339,
	"./icons/SVG/043.svg": 339,
	"./icons/SVG/044": 340,
	"./icons/SVG/044.svg": 340,
	"./icons/SVG/045": 341,
	"./icons/SVG/045.svg": 341,
	"./icons/SVG/046": 342,
	"./icons/SVG/046.svg": 342,
	"./icons/SVG/047": 343,
	"./icons/SVG/047.svg": 343,
	"./icons/SVG/048": 344,
	"./icons/SVG/048.svg": 344,
	"./icons/SVG/049": 345,
	"./icons/SVG/049.svg": 345,
	"./icons/SVG/050": 346,
	"./icons/SVG/050.svg": 346,
	"./icons/SVG/051": 347,
	"./icons/SVG/051.svg": 347,
	"./icons/SVG/052": 348,
	"./icons/SVG/052.svg": 348,
	"./icons/SVG/053": 349,
	"./icons/SVG/053.svg": 349,
	"./icons/SVG/054": 350,
	"./icons/SVG/054.svg": 350,
	"./icons/SVG/055": 351,
	"./icons/SVG/055.svg": 351,
	"./icons/SVG/056": 352,
	"./icons/SVG/056.svg": 352,
	"./icons/SVG/057": 353,
	"./icons/SVG/057.svg": 353,
	"./icons/SVG/058": 354,
	"./icons/SVG/058.svg": 354,
	"./icons/SVG/059": 355,
	"./icons/SVG/059.svg": 355,
	"./icons/SVG/060": 356,
	"./icons/SVG/060.svg": 356,
	"./icons/SVG/061": 357,
	"./icons/SVG/061.svg": 357,
	"./icons/SVG/062": 358,
	"./icons/SVG/062.svg": 358,
	"./icons/SVG/063": 359,
	"./icons/SVG/063.svg": 359,
	"./icons/SVG/064": 360,
	"./icons/SVG/064.svg": 360,
	"./icons/SVG/065": 361,
	"./icons/SVG/065.svg": 361,
	"./icons/SVG/066": 362,
	"./icons/SVG/066.svg": 362,
	"./icons/SVG/067": 363,
	"./icons/SVG/067.svg": 363,
	"./icons/SVG/068": 364,
	"./icons/SVG/068.svg": 364,
	"./icons/SVG/069": 365,
	"./icons/SVG/069.svg": 365,
	"./icons/SVG/070": 366,
	"./icons/SVG/070.svg": 366,
	"./icons/SVG/071": 367,
	"./icons/SVG/071.svg": 367,
	"./icons/SVG/072": 368,
	"./icons/SVG/072.svg": 368,
	"./icons/SVG/zoom_in": 369,
	"./icons/SVG/zoom_in.svg": 369,
	"./icons/SVG/zoom_in:Zone.Identifier": 902,
	"./icons/icons_large/10_heartbullet": 370,
	"./icons/icons_large/10_heartbullet.png": 370,
	"./icons/icons_large/11_heartbullet2": 371,
	"./icons/icons_large/11_heartbullet2.png": 371,
	"./icons/icons_large/12_bird": 372,
	"./icons/icons_large/12_bird.png": 372,
	"./icons/icons_large/13_cake": 373,
	"./icons/icons_large/13_cake.png": 373,
	"./icons/icons_large/14_letter": 374,
	"./icons/icons_large/14_letter.png": 374,
	"./icons/icons_large/15_2hearts": 375,
	"./icons/icons_large/15_2hearts.png": 375,
	"./icons/icons_large/16_lipstick": 376,
	"./icons/icons_large/16_lipstick.png": 376,
	"./icons/icons_large/17_arc": 377,
	"./icons/icons_large/17_arc.png": 377,
	"./icons/icons_large/18_todolist": 378,
	"./icons/icons_large/18_todolist.png": 378,
	"./icons/icons_large/19_ringbox": 379,
	"./icons/icons_large/19_ringbox.png": 379,
	"./icons/icons_large/1_flower": 380,
	"./icons/icons_large/1_flower.png": 380,
	"./icons/icons_large/20_videocamera": 381,
	"./icons/icons_large/20_videocamera.png": 381,
	"./icons/icons_large/21_presentbag": 382,
	"./icons/icons_large/21_presentbag.png": 382,
	"./icons/icons_large/22_photos": 383,
	"./icons/icons_large/22_photos.png": 383,
	"./icons/icons_large/23_car": 384,
	"./icons/icons_large/23_car.png": 384,
	"./icons/icons_large/24_cake2": 385,
	"./icons/icons_large/24_cake2.png": 385,
	"./icons/icons_large/25_crossedbullets": 386,
	"./icons/icons_large/25_crossedbullets.png": 386,
	"./icons/icons_large/26_bikefortwo": 387,
	"./icons/icons_large/26_bikefortwo.png": 387,
	"./icons/icons_large/27_saxafon": 388,
	"./icons/icons_large/27_saxafon.png": 388,
	"./icons/icons_large/28_camera": 389,
	"./icons/icons_large/28_camera.png": 389,
	"./icons/icons_large/29_twobirds": 390,
	"./icons/icons_large/29_twobirds.png": 390,
	"./icons/icons_large/2_dish": 391,
	"./icons/icons_large/2_dish.png": 391,
	"./icons/icons_large/30_earings": 392,
	"./icons/icons_large/30_earings.png": 392,
	"./icons/icons_large/31_plateset": 393,
	"./icons/icons_large/31_plateset.png": 393,
	"./icons/icons_large/32_palm": 394,
	"./icons/icons_large/32_palm.png": 394,
	"./icons/icons_large/33_invitation": 395,
	"./icons/icons_large/33_invitation.png": 395,
	"./icons/icons_large/34_airbaloon": 396,
	"./icons/icons_large/34_airbaloon.png": 396,
	"./icons/icons_large/35_heartbaloons": 397,
	"./icons/icons_large/35_heartbaloons.png": 397,
	"./icons/icons_large/36_candleholder": 398,
	"./icons/icons_large/36_candleholder.png": 398,
	"./icons/icons_large/37_twolistnote": 399,
	"./icons/icons_large/37_twolistnote.png": 399,
	"./icons/icons_large/38_menwomansign": 400,
	"./icons/icons_large/38_menwomansign.png": 400,
	"./icons/icons_large/39_bride": 401,
	"./icons/icons_large/39_bride.png": 401,
	"./icons/icons_large/3_lips": 402,
	"./icons/icons_large/3_lips.png": 402,
	"./icons/icons_large/40_groom": 403,
	"./icons/icons_large/40_groom.png": 403,
	"./icons/icons_large/41_key": 404,
	"./icons/icons_large/41_key.png": 404,
	"./icons/icons_large/42_marriageBed": 405,
	"./icons/icons_large/42_marriageBed.png": 405,
	"./icons/icons_large/43_decorationFlags": 406,
	"./icons/icons_large/43_decorationFlags.png": 406,
	"./icons/icons_large/44_smoking": 407,
	"./icons/icons_large/44_smoking.png": 407,
	"./icons/icons_large/45_coctail": 408,
	"./icons/icons_large/45_coctail.png": 408,
	"./icons/icons_large/46_church": 409,
	"./icons/icons_large/46_church.png": 409,
	"./icons/icons_large/47_shoppingBag": 410,
	"./icons/icons_large/47_shoppingBag.png": 410,
	"./icons/icons_large/48_openedLetter": 411,
	"./icons/icons_large/48_openedLetter.png": 411,
	"./icons/icons_large/49_peaceofCake": 412,
	"./icons/icons_large/49_peaceofCake.png": 412,
	"./icons/icons_large/4_cupcake": 413,
	"./icons/icons_large/4_cupcake.png": 413,
	"./icons/icons_large/50_music": 414,
	"./icons/icons_large/50_music.png": 414,
	"./icons/icons_large/51_bowtie": 415,
	"./icons/icons_large/51_bowtie.png": 415,
	"./icons/icons_large/52_key": 416,
	"./icons/icons_large/52_key.png": 416,
	"./icons/icons_large/53_shoewomen": 417,
	"./icons/icons_large/53_shoewomen.png": 417,
	"./icons/icons_large/54_bulletbow": 418,
	"./icons/icons_large/54_bulletbow.png": 418,
	"./icons/icons_large/55_shampagneBottle": 419,
	"./icons/icons_large/55_shampagneBottle.png": 419,
	"./icons/icons_large/56_diamond": 420,
	"./icons/icons_large/56_diamond.png": 420,
	"./icons/icons_large/57_rose": 421,
	"./icons/icons_large/57_rose.png": 421,
	"./icons/icons_large/58_ring": 422,
	"./icons/icons_large/58_ring.png": 422,
	"./icons/icons_large/59_twoglasses": 423,
	"./icons/icons_large/59_twoglasses.png": 423,
	"./icons/icons_large/5_plane": 424,
	"./icons/icons_large/5_plane.png": 424,
	"./icons/icons_large/60_flowerboquet": 425,
	"./icons/icons_large/60_flowerboquet.png": 425,
	"./icons/icons_large/61_foreverSign": 426,
	"./icons/icons_large/61_foreverSign.png": 426,
	"./icons/icons_large/62_twoBaloons": 427,
	"./icons/icons_large/62_twoBaloons.png": 427,
	"./icons/icons_large/63_microfone": 428,
	"./icons/icons_large/63_microfone.png": 428,
	"./icons/icons_large/64_tworings": 429,
	"./icons/icons_large/64_tworings.png": 429,
	"./icons/icons_large/65_firework": 430,
	"./icons/icons_large/65_firework.png": 430,
	"./icons/icons_large/66_presentBox": 431,
	"./icons/icons_large/66_presentBox.png": 431,
	"./icons/icons_large/67_doNotDisturbSign": 432,
	"./icons/icons_large/67_doNotDisturbSign.png": 432,
	"./icons/icons_large/68_location": 433,
	"./icons/icons_large/68_location.png": 433,
	"./icons/icons_large/69_twoCandles": 434,
	"./icons/icons_large/69_twoCandles.png": 434,
	"./icons/icons_large/6_bell": 435,
	"./icons/icons_large/6_bell.png": 435,
	"./icons/icons_large/70_lockforKeys": 436,
	"./icons/icons_large/70_lockforKeys.png": 436,
	"./icons/icons_large/71_chat": 437,
	"./icons/icons_large/71_chat.png": 437,
	"./icons/icons_large/72_bante": 438,
	"./icons/icons_large/72_bante.png": 438,
	"./icons/icons_large/7_flowers": 439,
	"./icons/icons_large/7_flowers.png": 439,
	"./icons/icons_large/8_calendar": 440,
	"./icons/icons_large/8_calendar.png": 440,
	"./icons/icons_large/9_dress": 441,
	"./icons/icons_large/9_dress.png": 441,
	"./icons/icons_small/10_heartbullet": 442,
	"./icons/icons_small/10_heartbullet.png": 442,
	"./icons/icons_small/11_heartbullet2": 443,
	"./icons/icons_small/11_heartbullet2.png": 443,
	"./icons/icons_small/12_bird": 444,
	"./icons/icons_small/12_bird.png": 444,
	"./icons/icons_small/13_cake": 445,
	"./icons/icons_small/13_cake.png": 445,
	"./icons/icons_small/14_letter": 446,
	"./icons/icons_small/14_letter.png": 446,
	"./icons/icons_small/15_2hearts": 447,
	"./icons/icons_small/15_2hearts.png": 447,
	"./icons/icons_small/16_lipstick": 448,
	"./icons/icons_small/16_lipstick.png": 448,
	"./icons/icons_small/17_arc": 449,
	"./icons/icons_small/17_arc.png": 449,
	"./icons/icons_small/18_todolist": 450,
	"./icons/icons_small/18_todolist.png": 450,
	"./icons/icons_small/19_ringbox": 451,
	"./icons/icons_small/19_ringbox.png": 451,
	"./icons/icons_small/1_flower": 452,
	"./icons/icons_small/1_flower.png": 452,
	"./icons/icons_small/20_videocamera": 453,
	"./icons/icons_small/20_videocamera.png": 453,
	"./icons/icons_small/21_presentbag": 454,
	"./icons/icons_small/21_presentbag.png": 454,
	"./icons/icons_small/22_photos": 455,
	"./icons/icons_small/22_photos.png": 455,
	"./icons/icons_small/23_car": 456,
	"./icons/icons_small/23_car.png": 456,
	"./icons/icons_small/24_cake2": 457,
	"./icons/icons_small/24_cake2.png": 457,
	"./icons/icons_small/25_crossedbullets": 458,
	"./icons/icons_small/25_crossedbullets.png": 458,
	"./icons/icons_small/26_bikefortwo": 459,
	"./icons/icons_small/26_bikefortwo.png": 459,
	"./icons/icons_small/27_saxafon": 460,
	"./icons/icons_small/27_saxafon.png": 460,
	"./icons/icons_small/28_camera": 461,
	"./icons/icons_small/28_camera.png": 461,
	"./icons/icons_small/29_twobirds": 462,
	"./icons/icons_small/29_twobirds.png": 462,
	"./icons/icons_small/2_dish": 463,
	"./icons/icons_small/2_dish.png": 463,
	"./icons/icons_small/30_earings": 464,
	"./icons/icons_small/30_earings.png": 464,
	"./icons/icons_small/31_plateset": 465,
	"./icons/icons_small/31_plateset.png": 465,
	"./icons/icons_small/32_palm": 466,
	"./icons/icons_small/32_palm.png": 466,
	"./icons/icons_small/33_invitation": 467,
	"./icons/icons_small/33_invitation.png": 467,
	"./icons/icons_small/34_airbaloon": 468,
	"./icons/icons_small/34_airbaloon.png": 468,
	"./icons/icons_small/35_heartbaloons": 469,
	"./icons/icons_small/35_heartbaloons.png": 469,
	"./icons/icons_small/36_candleholder": 470,
	"./icons/icons_small/36_candleholder.png": 470,
	"./icons/icons_small/37_twolistnote": 471,
	"./icons/icons_small/37_twolistnote.png": 471,
	"./icons/icons_small/38_menwomansign": 472,
	"./icons/icons_small/38_menwomansign.png": 472,
	"./icons/icons_small/39_bride": 473,
	"./icons/icons_small/39_bride.png": 473,
	"./icons/icons_small/3_lips": 474,
	"./icons/icons_small/3_lips.png": 474,
	"./icons/icons_small/40_groom": 475,
	"./icons/icons_small/40_groom.png": 475,
	"./icons/icons_small/41_key": 476,
	"./icons/icons_small/41_key.png": 476,
	"./icons/icons_small/42_marriageBed": 477,
	"./icons/icons_small/42_marriageBed.png": 477,
	"./icons/icons_small/43_decorationFlags": 478,
	"./icons/icons_small/43_decorationFlags.png": 478,
	"./icons/icons_small/44_smoking": 479,
	"./icons/icons_small/44_smoking.png": 479,
	"./icons/icons_small/45_coctail": 480,
	"./icons/icons_small/45_coctail.png": 480,
	"./icons/icons_small/46_church": 481,
	"./icons/icons_small/46_church.png": 481,
	"./icons/icons_small/47_shoppingBag": 482,
	"./icons/icons_small/47_shoppingBag.png": 482,
	"./icons/icons_small/48_openedLetter": 483,
	"./icons/icons_small/48_openedLetter.png": 483,
	"./icons/icons_small/49_peaceofCake": 484,
	"./icons/icons_small/49_peaceofCake.png": 484,
	"./icons/icons_small/4_cupcake": 485,
	"./icons/icons_small/4_cupcake.png": 485,
	"./icons/icons_small/50_music": 486,
	"./icons/icons_small/50_music.png": 486,
	"./icons/icons_small/51_bowtie": 487,
	"./icons/icons_small/51_bowtie.png": 487,
	"./icons/icons_small/52_key": 488,
	"./icons/icons_small/52_key.png": 488,
	"./icons/icons_small/53_shoewomen": 489,
	"./icons/icons_small/53_shoewomen.png": 489,
	"./icons/icons_small/54_bulletbow": 490,
	"./icons/icons_small/54_bulletbow.png": 490,
	"./icons/icons_small/55_shampagneBottle": 491,
	"./icons/icons_small/55_shampagneBottle.png": 491,
	"./icons/icons_small/56_diamond": 492,
	"./icons/icons_small/56_diamond.png": 492,
	"./icons/icons_small/57_rose": 493,
	"./icons/icons_small/57_rose.png": 493,
	"./icons/icons_small/58_ring": 494,
	"./icons/icons_small/58_ring.png": 494,
	"./icons/icons_small/59_twoglasses": 495,
	"./icons/icons_small/59_twoglasses.png": 495,
	"./icons/icons_small/5_plane": 496,
	"./icons/icons_small/5_plane.png": 496,
	"./icons/icons_small/60_flowerboquet": 497,
	"./icons/icons_small/60_flowerboquet.png": 497,
	"./icons/icons_small/61_foreverSign": 498,
	"./icons/icons_small/61_foreverSign.png": 498,
	"./icons/icons_small/62_twoBaloons": 499,
	"./icons/icons_small/62_twoBaloons.png": 499,
	"./icons/icons_small/63_microfone": 500,
	"./icons/icons_small/63_microfone.png": 500,
	"./icons/icons_small/64_tworings": 501,
	"./icons/icons_small/64_tworings.png": 501,
	"./icons/icons_small/65_firework": 502,
	"./icons/icons_small/65_firework.png": 502,
	"./icons/icons_small/66_presentBox": 503,
	"./icons/icons_small/66_presentBox.png": 503,
	"./icons/icons_small/67_doNotDisturbSign": 504,
	"./icons/icons_small/67_doNotDisturbSign.png": 504,
	"./icons/icons_small/68_location": 505,
	"./icons/icons_small/68_location.png": 505,
	"./icons/icons_small/69_twoCandles": 506,
	"./icons/icons_small/69_twoCandles.png": 506,
	"./icons/icons_small/6_bell": 507,
	"./icons/icons_small/6_bell.png": 507,
	"./icons/icons_small/70_lockforKeys": 508,
	"./icons/icons_small/70_lockforKeys.png": 508,
	"./icons/icons_small/71_chat": 509,
	"./icons/icons_small/71_chat.png": 509,
	"./icons/icons_small/72_bante": 510,
	"./icons/icons_small/72_bante.png": 510,
	"./icons/icons_small/7_flowers": 511,
	"./icons/icons_small/7_flowers.png": 511,
	"./icons/icons_small/8_calendar": 512,
	"./icons/icons_small/8_calendar.png": 512,
	"./icons/icons_small/9_dress": 513,
	"./icons/icons_small/9_dress.png": 513,
	"./icons/main/zoom_in.svg": 514,
	"./icons/main/zoom_in.svg.svg": 514,
	"./icons/main/zoom_in.svg:Zone.Identifier": 903,
	"./icons/vendors/accessories": 515,
	"./icons/vendors/accessories.png": 515,
	"./icons/vendors/agency": 516,
	"./icons/vendors/agency.png": 516,
	"./icons/vendors/bachelorparty": 517,
	"./icons/vendors/bachelorparty.png": 517,
	"./icons/vendors/band": 518,
	"./icons/vendors/band.png": 518,
	"./icons/vendors/bartender": 519,
	"./icons/vendors/bartender.png": 519,
	"./icons/vendors/cakes": 520,
	"./icons/vendors/cakes.png": 520,
	"./icons/vendors/caterers": 521,
	"./icons/vendors/caterers.png": 521,
	"./icons/vendors/caterers2": 522,
	"./icons/vendors/caterers2.png": 522,
	"./icons/vendors/churches": 523,
	"./icons/vendors/churches.png": 523,
	"./icons/vendors/decorator": 524,
	"./icons/vendors/decorator.png": 524,
	"./icons/vendors/entertainment": 525,
	"./icons/vendors/entertainment.png": 525,
	"./icons/vendors/eventhost": 526,
	"./icons/vendors/eventhost.png": 526,
	"./icons/vendors/first_dance": 527,
	"./icons/vendors/first_dance.png": 527,
	"./icons/vendors/hairstyle_makeup": 528,
	"./icons/vendors/hairstyle_makeup.png": 528,
	"./icons/vendors/large/accessories": 529,
	"./icons/vendors/large/accessories.png": 529,
	"./icons/vendors/large/agency": 530,
	"./icons/vendors/large/agency.png": 530,
	"./icons/vendors/large/bachelorparty": 531,
	"./icons/vendors/large/bachelorparty.png": 531,
	"./icons/vendors/large/band": 532,
	"./icons/vendors/large/band.png": 532,
	"./icons/vendors/large/bartender": 533,
	"./icons/vendors/large/bartender.png": 533,
	"./icons/vendors/large/cakes": 534,
	"./icons/vendors/large/cakes.png": 534,
	"./icons/vendors/large/caterers": 535,
	"./icons/vendors/large/caterers.png": 535,
	"./icons/vendors/large/caterers2": 536,
	"./icons/vendors/large/caterers2.png": 536,
	"./icons/vendors/large/churches": 537,
	"./icons/vendors/large/churches.png": 537,
	"./icons/vendors/large/decorator": 538,
	"./icons/vendors/large/decorator.png": 538,
	"./icons/vendors/large/entertainment": 539,
	"./icons/vendors/large/entertainment.png": 539,
	"./icons/vendors/large/eventhost": 540,
	"./icons/vendors/large/eventhost.png": 540,
	"./icons/vendors/large/first_dance": 541,
	"./icons/vendors/large/first_dance.png": 541,
	"./icons/vendors/large/hairstyle_makeup": 542,
	"./icons/vendors/large/hairstyle_makeup.png": 542,
	"./icons/vendors/large/marriageregistration": 543,
	"./icons/vendors/large/marriageregistration.png": 543,
	"./icons/vendors/large/paperthings": 544,
	"./icons/vendors/large/paperthings.png": 544,
	"./icons/vendors/large/photo": 545,
	"./icons/vendors/large/photo.png": 545,
	"./icons/vendors/large/soundandlights": 546,
	"./icons/vendors/large/soundandlights.png": 546,
	"./icons/vendors/large/suits": 547,
	"./icons/vendors/large/suits.png": 547,
	"./icons/vendors/large/transport": 548,
	"./icons/vendors/large/transport.png": 548,
	"./icons/vendors/large/venues": 549,
	"./icons/vendors/large/venues.png": 549,
	"./icons/vendors/large/videographer": 550,
	"./icons/vendors/large/videographer.png": 550,
	"./icons/vendors/large/weddingdress": 551,
	"./icons/vendors/large/weddingdress.png": 551,
	"./icons/vendors/large/weddingrings": 552,
	"./icons/vendors/large/weddingrings.png": 552,
	"./icons/vendors/large/weddingstops": 553,
	"./icons/vendors/large/weddingstops.png": 553,
	"./icons/vendors/marriageregistration": 554,
	"./icons/vendors/marriageregistration.png": 554,
	"./icons/vendors/paperthings": 555,
	"./icons/vendors/paperthings.png": 555,
	"./icons/vendors/photo": 556,
	"./icons/vendors/photo.png": 556,
	"./icons/vendors/soundandlights": 557,
	"./icons/vendors/soundandlights.png": 557,
	"./icons/vendors/suits": 558,
	"./icons/vendors/suits.png": 558,
	"./icons/vendors/transport": 559,
	"./icons/vendors/transport.png": 559,
	"./icons/vendors/venues": 560,
	"./icons/vendors/venues.png": 560,
	"./icons/vendors/videographer": 561,
	"./icons/vendors/videographer.png": 561,
	"./icons/vendors/webpic/accessories": 562,
	"./icons/vendors/webpic/accessories.webp": 562,
	"./icons/vendors/webpic/agency": 563,
	"./icons/vendors/webpic/agency.webp": 563,
	"./icons/vendors/webpic/bachelorparty": 564,
	"./icons/vendors/webpic/bachelorparty.webp": 564,
	"./icons/vendors/webpic/band": 565,
	"./icons/vendors/webpic/band.webp": 565,
	"./icons/vendors/webpic/bartender": 566,
	"./icons/vendors/webpic/bartender.webp": 566,
	"./icons/vendors/webpic/cakes": 567,
	"./icons/vendors/webpic/cakes.webp": 567,
	"./icons/vendors/webpic/caterers": 568,
	"./icons/vendors/webpic/caterers.webp": 568,
	"./icons/vendors/webpic/caterers2": 569,
	"./icons/vendors/webpic/caterers2.webp": 569,
	"./icons/vendors/webpic/churches": 570,
	"./icons/vendors/webpic/churches.webp": 570,
	"./icons/vendors/webpic/decorator": 571,
	"./icons/vendors/webpic/decorator.webp": 571,
	"./icons/vendors/webpic/entertainment": 572,
	"./icons/vendors/webpic/entertainment.webp": 572,
	"./icons/vendors/webpic/eventhost": 573,
	"./icons/vendors/webpic/eventhost.webp": 573,
	"./icons/vendors/webpic/first_dance": 574,
	"./icons/vendors/webpic/first_dance.webp": 574,
	"./icons/vendors/webpic/hairstyle_makeup": 575,
	"./icons/vendors/webpic/hairstyle_makeup.webp": 575,
	"./icons/vendors/webpic/marriageregistration": 576,
	"./icons/vendors/webpic/marriageregistration.webp": 576,
	"./icons/vendors/webpic/paperthings": 577,
	"./icons/vendors/webpic/paperthings.webp": 577,
	"./icons/vendors/webpic/photo": 578,
	"./icons/vendors/webpic/photo.webp": 578,
	"./icons/vendors/webpic/soundandlights": 579,
	"./icons/vendors/webpic/soundandlights.webp": 579,
	"./icons/vendors/webpic/suits": 580,
	"./icons/vendors/webpic/suits.webp": 580,
	"./icons/vendors/webpic/transport": 581,
	"./icons/vendors/webpic/transport.webp": 581,
	"./icons/vendors/webpic/venues": 582,
	"./icons/vendors/webpic/venues.webp": 582,
	"./icons/vendors/webpic/videographer": 583,
	"./icons/vendors/webpic/videographer.webp": 583,
	"./icons/vendors/webpic/weddingdress": 584,
	"./icons/vendors/webpic/weddingdress.webp": 584,
	"./icons/vendors/webpic/weddingrings": 585,
	"./icons/vendors/webpic/weddingrings.webp": 585,
	"./icons/vendors/webpic/weddingstops": 586,
	"./icons/vendors/webpic/weddingstops.webp": 586,
	"./icons/vendors/weddingdress": 587,
	"./icons/vendors/weddingdress.png": 587,
	"./icons/vendors/weddingrings": 588,
	"./icons/vendors/weddingrings.png": 588,
	"./icons/vendors/weddingstops": 589,
	"./icons/vendors/weddingstops.png": 589,
	"./landing_page/13": 63,
	"./landing_page/13.png": 63,
	"./landing_page/13.webp": 904,
	"./landing_page/13_mobile": 590,
	"./landing_page/13_mobile.webp": 590,
	"./landing_page/2023/album/album_large_en": 64,
	"./landing_page/2023/album/album_large_en.png": 64,
	"./landing_page/2023/album/album_large_en.webp": 905,
	"./landing_page/2023/album/album_large_lv": 65,
	"./landing_page/2023/album/album_large_lv.png": 65,
	"./landing_page/2023/album/album_large_lv.webp": 906,
	"./landing_page/2023/album/album_large_ru": 591,
	"./landing_page/2023/album/album_large_ru.webp": 591,
	"./landing_page/2023/album/album_mobile_en": 66,
	"./landing_page/2023/album/album_mobile_en.png": 66,
	"./landing_page/2023/album/album_mobile_en.webp": 907,
	"./landing_page/2023/album/album_mobile_lv": 67,
	"./landing_page/2023/album/album_mobile_lv.png": 67,
	"./landing_page/2023/album/album_mobile_lv.webp": 908,
	"./landing_page/2023/album/album_mobile_ru": 592,
	"./landing_page/2023/album/album_mobile_ru.webp": 592,
	"./landing_page/2023/album_large_en": 593,
	"./landing_page/2023/album_large_en.png": 593,
	"./landing_page/2023/album_large_lv": 594,
	"./landing_page/2023/album_large_lv.png": 594,
	"./landing_page/2023/album_mobile_en": 595,
	"./landing_page/2023/album_mobile_en.png": 595,
	"./landing_page/2023/album_mobile_lv": 596,
	"./landing_page/2023/album_mobile_lv.png": 596,
	"./landing_page/2023/header_img": 68,
	"./landing_page/2023/header_img.jpg": 68,
	"./landing_page/2023/header_img.webp": 909,
	"./landing_page/2023/header_imgs": 597,
	"./landing_page/2023/header_imgs.jpg": 597,
	"./landing_page/2023/home_main2_old": 598,
	"./landing_page/2023/home_main2_old.webp": 598,
	"./landing_page/2023/home_main_mobile2_old": 599,
	"./landing_page/2023/home_main_mobile2_old.png": 599,
	"./landing_page/2023/main_home_image": 600,
	"./landing_page/2023/main_home_image.png": 600,
	"./landing_page/2023/main_home_image_mob": 69,
	"./landing_page/2023/main_home_image_mob.png": 69,
	"./landing_page/2023/main_home_image_mob.webp": 910,
	"./landing_page/2023/main_home_image_sm": 70,
	"./landing_page/2023/main_home_image_sm.png": 70,
	"./landing_page/2023/main_home_image_sm.webp": 911,
	"./landing_page/2023/tools/budget_en": 601,
	"./landing_page/2023/tools/budget_en.webp": 601,
	"./landing_page/2023/tools/budget_en_mobile": 602,
	"./landing_page/2023/tools/budget_en_mobile.webp": 602,
	"./landing_page/2023/tools/budget_lv": 603,
	"./landing_page/2023/tools/budget_lv.webp": 603,
	"./landing_page/2023/tools/budget_lv_mobile": 604,
	"./landing_page/2023/tools/budget_lv_mobile.webp": 604,
	"./landing_page/2023/tools/budget_ru": 605,
	"./landing_page/2023/tools/budget_ru.webp": 605,
	"./landing_page/2023/tools/budget_ru_mobile": 606,
	"./landing_page/2023/tools/budget_ru_mobile.webp": 606,
	"./landing_page/2023/tools/guests_en": 607,
	"./landing_page/2023/tools/guests_en.webp": 607,
	"./landing_page/2023/tools/guests_en_mobile": 608,
	"./landing_page/2023/tools/guests_en_mobile.webp": 608,
	"./landing_page/2023/tools/guests_lv": 609,
	"./landing_page/2023/tools/guests_lv.webp": 609,
	"./landing_page/2023/tools/guests_lv_mobile": 610,
	"./landing_page/2023/tools/guests_lv_mobile.webp": 610,
	"./landing_page/2023/tools/guests_ru": 611,
	"./landing_page/2023/tools/guests_ru.webp": 611,
	"./landing_page/2023/tools/guests_ru_mobile": 612,
	"./landing_page/2023/tools/guests_ru_mobile.webp": 612,
	"./landing_page/2023/tools/png/budget_en": 613,
	"./landing_page/2023/tools/png/budget_en.png": 613,
	"./landing_page/2023/tools/png/budget_lv": 614,
	"./landing_page/2023/tools/png/budget_lv.png": 614,
	"./landing_page/2023/tools/png/guests_en": 615,
	"./landing_page/2023/tools/png/guests_en.png": 615,
	"./landing_page/2023/tools/png/guests_lv": 616,
	"./landing_page/2023/tools/png/guests_lv.png": 616,
	"./landing_page/2023/tools/png/tables_en": 617,
	"./landing_page/2023/tools/png/tables_en.png": 617,
	"./landing_page/2023/tools/png/tables_lv": 618,
	"./landing_page/2023/tools/png/tables_lv.png": 618,
	"./landing_page/2023/tools/png/todo_en": 619,
	"./landing_page/2023/tools/png/todo_en.png": 619,
	"./landing_page/2023/tools/png/todo_lv": 620,
	"./landing_page/2023/tools/png/todo_lv.png": 620,
	"./landing_page/2023/tools/png/vision_en": 621,
	"./landing_page/2023/tools/png/vision_en.png": 621,
	"./landing_page/2023/tools/png/vision_lv": 622,
	"./landing_page/2023/tools/png/vision_lv.png": 622,
	"./landing_page/2023/tools/tables_en": 623,
	"./landing_page/2023/tools/tables_en.webp": 623,
	"./landing_page/2023/tools/tables_en_mobile": 624,
	"./landing_page/2023/tools/tables_en_mobile.webp": 624,
	"./landing_page/2023/tools/tables_lv": 625,
	"./landing_page/2023/tools/tables_lv.webp": 625,
	"./landing_page/2023/tools/tables_lv_mobile": 626,
	"./landing_page/2023/tools/tables_lv_mobile.webp": 626,
	"./landing_page/2023/tools/tables_ru": 627,
	"./landing_page/2023/tools/tables_ru.webp": 627,
	"./landing_page/2023/tools/tables_ru_mobile": 628,
	"./landing_page/2023/tools/tables_ru_mobile.webp": 628,
	"./landing_page/2023/tools/todo_en": 629,
	"./landing_page/2023/tools/todo_en.webp": 629,
	"./landing_page/2023/tools/todo_en_mobile": 630,
	"./landing_page/2023/tools/todo_en_mobile.webp": 630,
	"./landing_page/2023/tools/todo_lv": 631,
	"./landing_page/2023/tools/todo_lv.webp": 631,
	"./landing_page/2023/tools/todo_lv_mobile": 632,
	"./landing_page/2023/tools/todo_lv_mobile.webp": 632,
	"./landing_page/2023/tools/todo_ru": 633,
	"./landing_page/2023/tools/todo_ru.webp": 633,
	"./landing_page/2023/tools/todo_ru_mobile": 634,
	"./landing_page/2023/tools/todo_ru_mobile.webp": 634,
	"./landing_page/2023/tools/vision_en": 635,
	"./landing_page/2023/tools/vision_en.webp": 635,
	"./landing_page/2023/tools/vision_en_mobile": 636,
	"./landing_page/2023/tools/vision_en_mobile.webp": 636,
	"./landing_page/2023/tools/vision_lv": 637,
	"./landing_page/2023/tools/vision_lv.webp": 637,
	"./landing_page/2023/tools/vision_lv_mobile": 638,
	"./landing_page/2023/tools/vision_lv_mobile.webp": 638,
	"./landing_page/2023/tools/vision_ru": 639,
	"./landing_page/2023/tools/vision_ru.webp": 639,
	"./landing_page/2023/tools/vision_ru_mobile": 640,
	"./landing_page/2023/tools/vision_ru_mobile.webp": 640,
	"./landing_page/2023/webpage/majaslapa-diziani": 641,
	"./landing_page/2023/webpage/majaslapa-diziani.webp": 641,
	"./landing_page/2023/webpage/majaslapa-parvaldiba": 642,
	"./landing_page/2023/webpage/majaslapa-parvaldiba.webp": 642,
	"./landing_page/2023/webpage/majaslapa-preview": 643,
	"./landing_page/2023/webpage/majaslapa-preview.webp": 643,
	"./landing_page/2023/webpage/majaslapa-programma": 644,
	"./landing_page/2023/webpage/majaslapa-programma.webp": 644,
	"./landing_page/2023/webpage/majaslapa-sakumlapa": 645,
	"./landing_page/2023/webpage/majaslapa-sakumlapa.webp": 645,
	"./landing_page/4": 71,
	"./landing_page/4.png": 71,
	"./landing_page/4.webp": 912,
	"./landing_page/775074": 646,
	"./landing_page/775074.webp": 646,
	"./landing_page/dashboard": 72,
	"./landing_page/dashboard (copy)": 647,
	"./landing_page/dashboard (copy).webp": 647,
	"./landing_page/dashboard.png": 72,
	"./landing_page/dashboard.webp": 913,
	"./landing_page/dashboard_mobile": 648,
	"./landing_page/dashboard_mobile.webp": 648,
	"./landing_page/digweddash2": 649,
	"./landing_page/digweddash2.png": 649,
	"./landing_page/digweddash3": 650,
	"./landing_page/digweddash3.png": 650,
	"./landing_page/digweddash4": 73,
	"./landing_page/digweddash4.png": 73,
	"./landing_page/digweddash4.webp": 914,
	"./landing_page/digweddash4_mobile": 74,
	"./landing_page/digweddash4_mobile.png": 74,
	"./landing_page/digweddash4_mobile.webp": 915,
	"./landing_page/failiem_upload_mobile": 651,
	"./landing_page/failiem_upload_mobile (copy)": 652,
	"./landing_page/failiem_upload_mobile (copy).png": 652,
	"./landing_page/failiem_upload_mobile.png": 651,
	"./landing_page/failiem_upload_pc": 653,
	"./landing_page/failiem_upload_pc (copy)": 654,
	"./landing_page/failiem_upload_pc (copy).png": 654,
	"./landing_page/failiem_upload_pc.png": 653,
	"./landing_page/header_pc": 655,
	"./landing_page/header_pc.png": 655,
	"./landing_page/home_main": 656,
	"./landing_page/home_main.webp": 656,
	"./landing_page/home_main2": 75,
	"./landing_page/home_main2.png": 75,
	"./landing_page/home_main2.webp": 916,
	"./landing_page/home_main_mobile": 657,
	"./landing_page/home_main_mobile.webp": 657,
	"./landing_page/home_main_mobile2": 76,
	"./landing_page/home_main_mobile2.png": 76,
	"./landing_page/home_main_mobile2.webp": 917,
	"./landing_page/kazu_budzets": 77,
	"./landing_page/kazu_budzets.png": 77,
	"./landing_page/kazu_budzets.webp": 918,
	"./landing_page/kazu_budzets_mobile": 658,
	"./landing_page/kazu_budzets_mobile.webp": 658,
	"./landing_page/kazu_uzdevumi": 78,
	"./landing_page/kazu_uzdevumi.png": 78,
	"./landing_page/kazu_uzdevumi.webp": 919,
	"./landing_page/kazu_uzdevumi_mobile": 659,
	"./landing_page/kazu_uzdevumi_mobile.webp": 659,
	"./landing_page/kazu_viesi": 79,
	"./landing_page/kazu_viesi.png": 79,
	"./landing_page/kazu_viesi.webp": 920,
	"./landing_page/kazu_viesi_mobile": 660,
	"./landing_page/kazu_viesi_mobile.webp": 660,
	"./landing_page/kazu_vizija": 80,
	"./landing_page/kazu_vizija.png": 80,
	"./landing_page/kazu_vizija.webp": 921,
	"./landing_page/kazu_vizija_mobile": 81,
	"./landing_page/kazu_vizija_mobile.png": 81,
	"./landing_page/kazu_vizija_mobile.webp": 922,
	"./landing_page/liaa_inkubatora_atbalsts": 82,
	"./landing_page/liaa_inkubatora_atbalsts.png": 82,
	"./landing_page/liaa_inkubatora_atbalsts.webp": 923,
	"./landing_page/main_phone": 83,
	"./landing_page/main_phone.png": 83,
	"./landing_page/main_phone.webp": 924,
	"./landing_page/majaslapa-diziani": 661,
	"./landing_page/majaslapa-diziani.png": 661,
	"./landing_page/majaslapa-parvaldiba": 662,
	"./landing_page/majaslapa-parvaldiba.png": 662,
	"./landing_page/majaslapa-preview": 663,
	"./landing_page/majaslapa-preview (copy)": 664,
	"./landing_page/majaslapa-preview (copy).png": 664,
	"./landing_page/majaslapa-preview.png": 663,
	"./landing_page/majaslapa-programma": 665,
	"./landing_page/majaslapa-programma.png": 665,
	"./landing_page/majaslapa-sakumlapa": 666,
	"./landing_page/majaslapa-sakumlapa.png": 666,
	"./landing_page/mes": 84,
	"./landing_page/mes.jpg": 84,
	"./landing_page/mes.webp": 925,
	"./landing_page/pakalpojumu_sniedzeji": 85,
	"./landing_page/pakalpojumu_sniedzeji.png": 85,
	"./landing_page/pakalpojumu_sniedzeji.webp": 926,
	"./landing_page/pakalpojumu_sniedzeji_mobile": 86,
	"./landing_page/pakalpojumu_sniedzeji_mobile.png": 86,
	"./landing_page/pakalpojumu_sniedzeji_mobile.webp": 927,
	"./landing_page/peteris_un_sandra_1": 87,
	"./landing_page/peteris_un_sandra_1.jpg": 87,
	"./landing_page/peteris_un_sandra_1.webp": 928,
	"./landing_page/screen_mobile": 88,
	"./landing_page/screen_mobile.png": 88,
	"./landing_page/screen_mobile.webp": 929,
	"./landing_page/screen_pc": 89,
	"./landing_page/screen_pc.png": 89,
	"./landing_page/screen_pc.webp": 930,
	"./landing_page/screen_pc_mobile": 667,
	"./landing_page/screen_pc_mobile.webp": 667,
	"./landing_page/uzdevumi": 90,
	"./landing_page/uzdevumi.png": 90,
	"./landing_page/uzdevumi.webp": 931,
	"./landing_page/velme_atskirties": 91,
	"./landing_page/velme_atskirties.jpg": 91,
	"./landing_page/velme_atskirties.webp": 932,
	"./landing_page/viesi": 92,
	"./landing_page/viesi.png": 92,
	"./landing_page/viesi.webp": 933,
	"./loader": 668,
	"./loader.gif": 668,
	"./loader_small": 669,
	"./loader_small.gif": 669,
	"./logos/alogo1_small_white": 670,
	"./logos/alogo1_small_white.png": 670,
	"./logos/logo1_small": 671,
	"./logos/logo1_small.png": 671,
	"./logos/logo1_small_white": 672,
	"./logos/logo1_small_white.webp": 672,
	"./logos/logo_large": 673,
	"./logos/logo_large (copy)": 674,
	"./logos/logo_large (copy).png": 674,
	"./logos/logo_large.png": 673,
	"./logos/logo_large_wbg": 675,
	"./logos/logo_large_wbg.jpg": 675,
	"./logos/logo_svg": 676,
	"./logos/logo_svg.svg": 676,
	"./logos/logo_thumb": 677,
	"./logos/logo_thumb.png": 677,
	"./maps/google_map": 678,
	"./maps/google_map.jpg": 678,
	"./maps/pins/cluster2": 679,
	"./maps/pins/cluster2.png": 679,
	"./maps/pins/digi_pin": 680,
	"./maps/pins/digi_pin.png": 680,
	"./maps/pins/digi_pin_large": 681,
	"./maps/pins/digi_pin_large (copy)": 682,
	"./maps/pins/digi_pin_large (copy).png": 682,
	"./maps/pins/digi_pin_large.png": 681,
	"./maps/pins/pin": 683,
	"./maps/pins/pin.png": 683,
	"./maps/pins/pin1": 684,
	"./maps/pins/pin1.png": 684,
	"./maps/waze": 685,
	"./maps/waze.png": 685,
	"./meta/digi-wedding": 686,
	"./meta/digi-wedding-en": 687,
	"./meta/digi-wedding-en.png": 687,
	"./meta/digi-wedding-lv": 688,
	"./meta/digi-wedding-lv.png": 688,
	"./meta/digi-wedding-ru": 689,
	"./meta/digi-wedding-ru.png": 689,
	"./meta/digi-wedding.png": 686,
	"./meta/kazu-blogs": 690,
	"./meta/kazu-blogs.jpg": 690,
	"./meta/logo": 691,
	"./meta/logo.png": 691,
	"./meta/pakalpojumu_sniedzeji": 692,
	"./meta/pakalpojumu_sniedzeji.jpg": 692,
	"./pattern": 693,
	"./pattern.png": 693,
	"./pin": 694,
	"./pin.png": 694,
	"./placholder_logo": 695,
	"./placholder_logo.png": 695,
	"./posts/2563286": 696,
	"./posts/2563286.jpg": 696,
	"./posts/brivdaba": 697,
	"./posts/brivdaba.jpg": 697,
	"./posts/budget-jar": 698,
	"./posts/budget-jar.jpg": 698,
	"./posts/celebrate_together": 699,
	"./posts/celebrate_together.jpg": 699,
	"./posts/chess": 700,
	"./posts/chess.jpg": 700,
	"./posts/comics": 701,
	"./posts/comics.jpg": 701,
	"./posts/contract": 702,
	"./posts/contract.jpg": 702,
	"./posts/digital_invitation": 703,
	"./posts/digital_invitation.jpg": 703,
	"./posts/eco_nature": 704,
	"./posts/eco_nature.jpg": 704,
	"./posts/fingerprints": 705,
	"./posts/fingerprints.jpg": 705,
	"./posts/flower_pots": 706,
	"./posts/flower_pots.jpg": 706,
	"./posts/flower_reuse": 707,
	"./posts/flower_reuse.jpg": 707,
	"./posts/get_away_weddings": 708,
	"./posts/get_away_weddings.jpg": 708,
	"./posts/happy-wedding": 709,
	"./posts/happy-wedding.jpg": 709,
	"./posts/jar": 710,
	"./posts/jar.jpg": 710,
	"./posts/karaoke": 711,
	"./posts/karaoke.jpg": 711,
	"./posts/kazas-divata": 712,
	"./posts/kazas-divata.jpg": 712,
	"./posts/master_Class": 713,
	"./posts/master_Class.jpg": 713,
	"./posts/micro_weddings": 714,
	"./posts/micro_weddings.jpg": 714,
	"./posts/no_deal_with_vendors": 715,
	"./posts/no_deal_with_vendors.jpg": 715,
	"./posts/no_social_sites": 716,
	"./posts/no_social_sites.jpg": 716,
	"./posts/organizer": 717,
	"./posts/organizer.jpg": 717,
	"./posts/piggy-bank": 718,
	"./posts/piggy-bank.jpg": 718,
	"./posts/plan_budget": 719,
	"./posts/plan_budget.jpg": 719,
	"./posts/puzzle": 720,
	"./posts/puzzle.jpg": 720,
	"./posts/sedvietas": 721,
	"./posts/sedvietas.jpg": 721,
	"./posts/stones": 722,
	"./posts/stones.jpg": 722,
	"./posts/wait_for_shopping": 723,
	"./posts/wait_for_shopping.jpg": 723,
	"./posts/webpage": 724,
	"./posts/webpage.png": 724,
	"./posts/wedding-alcko": 725,
	"./posts/wedding-alcko.jpg": 725,
	"./posts/wedding-food": 726,
	"./posts/wedding-food.jpg": 726,
	"./posts/wedding-guests": 727,
	"./posts/wedding-guests.jpg": 727,
	"./posts/wedding-location": 728,
	"./posts/wedding-location.jpg": 728,
	"./posts/wedding-room": 729,
	"./posts/wedding-room.jpg": 729,
	"./posts/wedding_food_art": 730,
	"./posts/wedding_food_art.jpg": 730,
	"./posts/wedding_planning_tasks1": 731,
	"./posts/wedding_planning_tasks1.png": 731,
	"./posts/wedding_planning_tasks2": 732,
	"./posts/wedding_planning_tasks2.png": 732,
	"./posts/wedding_planning_tasks3": 733,
	"./posts/wedding_planning_tasks3.png": 733,
	"./posts/wedding_website": 734,
	"./posts/wedding_website.png": 734,
	"./posts/why_choose_winter_wedding2": 735,
	"./posts/why_choose_winter_wedding2.jpg": 735,
	"./posts/why_choose_winter_wedding3": 736,
	"./posts/why_choose_winter_wedding3.jpg": 736,
	"./posts/why_choose_winter_wedding4": 737,
	"./posts/why_choose_winter_wedding4.jpg": 737,
	"./posts/why_choose_winter_wedding5": 738,
	"./posts/why_choose_winter_wedding5.jpg": 738,
	"./posts/winter_wedding": 739,
	"./posts/winter_wedding.jpg": 739,
	"./posts/zoom-calls": 740,
	"./posts/zoom-calls.jpg": 740,
	"./preview/browser_header": 741,
	"./preview/browser_header.png": 741,
	"./preview/browser_header_sm": 742,
	"./preview/browser_header_sm.png": 742,
	"./preview/preview_laptop": 743,
	"./preview/preview_laptop.png": 743,
	"./preview/preview_laptop_2": 744,
	"./preview/preview_laptop_2.png": 744,
	"./products/demo/earphones": 745,
	"./products/demo/earphones.jpg": 745,
	"./products/demo/headphone": 746,
	"./products/demo/headphone.jpg": 746,
	"./products/demo/monitor": 747,
	"./products/demo/monitor.png": 747,
	"./products/demo/slideri1": 748,
	"./products/demo/slideri1.jpg": 748,
	"./products/demo/slideri2": 749,
	"./products/demo/slideri2.jpg": 749,
	"./products/demo/slideri3": 750,
	"./products/demo/slideri3.jpg": 750,
	"./products/demo/slideri4": 751,
	"./products/demo/slideri4.jpg": 751,
	"./products/demo/speaker": 752,
	"./products/demo/speaker.jpg": 752,
	"./products/demo/vrglasses": 93,
	"./products/demo/vrglasses.jpg": 934,
	"./products/demo/vrglasses.png": 93,
	"./sections/home/bride": 94,
	"./sections/home/bride.jpg": 935,
	"./sections/home/bride.png": 94,
	"./sections/home/bride_gr": 753,
	"./sections/home/bride_gr.png": 753,
	"./sections/home/grrom_gr": 754,
	"./sections/home/grrom_gr.png": 754,
	"./shop/box_dimension": 755,
	"./shop/box_dimension.png": 755,
	"./shop/box_dimensions": 756,
	"./shop/box_dimensions.png": 756,
	"./social/envelope-regular": 757,
	"./social/envelope-regular.svg": 757,
	"./social/envelope-solid": 758,
	"./social/envelope-solid.svg": 758,
	"./social/facebook-f-brands": 759,
	"./social/facebook-f-brands.svg": 759,
	"./social/facebook-square-brands": 760,
	"./social/facebook-square-brands.svg": 760,
	"./social/pinterest-brands": 761,
	"./social/pinterest-brands.svg": 761,
	"./social/pinterest-square-brands": 762,
	"./social/pinterest-square-brands.svg": 762,
	"./social/telegram-brands": 763,
	"./social/telegram-brands.svg": 763,
	"./social/telegram-plane-brands": 764,
	"./social/telegram-plane-brands.svg": 764,
	"./social/twitter-brands": 765,
	"./social/twitter-brands.svg": 765,
	"./social/twitter-square-brands": 766,
	"./social/twitter-square-brands.svg": 766,
	"./social/whatsapp-brands": 767,
	"./social/whatsapp-brands.svg": 767,
	"./social/whatsapp-square-brands": 768,
	"./social/whatsapp-square-brands.svg": 768,
	"./tables/1side": 769,
	"./tables/1side.png": 769,
	"./tables/2side": 770,
	"./tables/2side.png": 770,
	"./tables/no_seats": 771,
	"./tables/no_seats.png": 771,
	"./tables/round": 772,
	"./tables/round.png": 772,
	"./tables/square": 773,
	"./tables/square.png": 773,
	"./themes/autumn_ice_queen/main_bg": 774,
	"./themes/autumn_ice_queen/main_bg.png": 774,
	"./themes/autumn_terracotta/main_bg": 775,
	"./themes/autumn_terracotta/main_bg.png": 775,
	"./themes/could_touch/main_bg": 776,
	"./themes/could_touch/main_bg.png": 776,
	"./themes/deep_space/header": 777,
	"./themes/deep_space/header.png": 777,
	"./themes/deep_space/main_bg": 778,
	"./themes/deep_space/main_bg.png": 778,
	"./themes/lemon_freshness/lemon": 779,
	"./themes/lemon_freshness/lemon.png": 779,
	"./themes/lemon_freshness/lemon_croped": 780,
	"./themes/lemon_freshness/lemon_croped.png": 780,
	"./themes/mandy/10": 781,
	"./themes/mandy/10.webp": 781,
	"./themes/mandy/11": 782,
	"./themes/mandy/11.png": 782,
	"./themes/mandy/12": 783,
	"./themes/mandy/12.png": 783,
	"./themes/mandy/13": 784,
	"./themes/mandy/13 (copy)": 785,
	"./themes/mandy/13 (copy).png": 785,
	"./themes/mandy/13.png": 784,
	"./themes/mandy/14": 786,
	"./themes/mandy/14.png": 786,
	"./themes/mandy/15": 787,
	"./themes/mandy/15.png": 787,
	"./themes/mandy/16": 788,
	"./themes/mandy/16.png": 788,
	"./themes/mandy/2": 789,
	"./themes/mandy/2.jpg": 789,
	"./themes/mandy/3": 790,
	"./themes/mandy/3.png": 790,
	"./themes/mandy/4": 791,
	"./themes/mandy/4.png": 791,
	"./themes/mandy/5": 792,
	"./themes/mandy/5.jpg": 792,
	"./themes/mandy/6": 793,
	"./themes/mandy/6 (copy)": 794,
	"./themes/mandy/6 (copy).jpg": 794,
	"./themes/mandy/6.jpg": 793,
	"./themes/mandy/7": 795,
	"./themes/mandy/7.webp": 795,
	"./themes/mandy/8": 796,
	"./themes/mandy/8.jpg": 796,
	"./themes/mandy/9": 797,
	"./themes/mandy/9.jpg": 797,
	"./themes/mandy/bg1": 798,
	"./themes/mandy/bg1.png": 798,
	"./themes/pink_softness/main_bg": 799,
	"./themes/pink_softness/main_bg.png": 799,
	"./themes/pink_softness/main_bg2": 800,
	"./themes/pink_softness/main_bg2.png": 800,
	"./themes/pink_softness/main_bg3": 801,
	"./themes/pink_softness/main_bg3.png": 801,
	"./themes/spring_bohemian/Greenery-Wedding": 802,
	"./themes/spring_bohemian/Greenery-Wedding.png": 802,
	"./themes/spring_bohemian/ring": 803,
	"./themes/spring_bohemian/ring.png": 803,
	"./themes/spring_bohemian/ring_semi_transparent": 804,
	"./themes/spring_bohemian/ring_semi_transparent.png": 804,
	"./themes/spring_bohemian/ring_semi_transparent1": 805,
	"./themes/spring_bohemian/ring_semi_transparent1.png": 805,
	"./themes/spring_bohemian/ring_semi_transparent2": 806,
	"./themes/spring_bohemian/ring_semi_transparent2.png": 806,
	"./themes/spring_bohemian/ring_semi_transparent3": 807,
	"./themes/spring_bohemian/ring_semi_transparent3.png": 807,
	"./vendors/category1": 808,
	"./vendors/category1.jpg": 808,
	"./vendors/category2": 809,
	"./vendors/category2.jpg": 809,
	"./vendors/category3": 810,
	"./vendors/category3.jpg": 810,
	"./vendors/category4": 811,
	"./vendors/category4.jpg": 811,
	"./vendors/missing_vendors": 812,
	"./vendors/missing_vendors (copy)": 813,
	"./vendors/missing_vendors (copy).png": 813,
	"./vendors/missing_vendors.png": 812,
	"./vendors/missing_vendors_small": 814,
	"./vendors/missing_vendors_small.png": 814,
	"./vendors/verndors": 815,
	"./vendors/verndors.png": 815,
	"./vendors/verndors_small": 816,
	"./vendors/verndors_small.png": 816,
	"./video/main-digiwedding-video.mp4": 936,
	"./vision/2": 817,
	"./vision/2.jpg": 817,
	"./vision/board_bg": 818,
	"./vision/board_bg.png": 818,
	"./vision/dark_bg": 819,
	"./vision/dark_bg.jpg": 819,
	"./wedding/11": 820,
	"./wedding/11.jpg": 820,
	"./wedding/12": 821,
	"./wedding/12.jpg": 821,
	"./wedding/13": 822,
	"./wedding/13.jpg": 822,
	"./wedding/15": 823,
	"./wedding/15.jpg": 823,
	"./wedding/16": 824,
	"./wedding/16.jpg": 824,
	"./wedding/17": 825,
	"./wedding/17.jpg": 825,
	"./wedding/18": 826,
	"./wedding/18.jpg": 826,
	"./wedding/19": 827,
	"./wedding/19.jpg": 827,
	"./wedding/20": 828,
	"./wedding/20.jpg": 828,
	"./wedding/21": 829,
	"./wedding/21.jpg": 829,
	"./wedding/22": 830,
	"./wedding/22.jpg": 830,
	"./wedding/23": 831,
	"./wedding/23.jpg": 831,
	"./wedding/24": 832,
	"./wedding/24.jpg": 832,
	"./wedding/25": 833,
	"./wedding/25.jpg": 833,
	"./wedding/26": 834,
	"./wedding/26.jpg": 834,
	"./wedding/27": 835,
	"./wedding/27.jpg": 835,
	"./wedding/28": 836,
	"./wedding/28.jpg": 836,
	"./wedding/events/afterwedding": 837,
	"./wedding/events/afterwedding.jpg": 837,
	"./wedding/events/cocktail": 838,
	"./wedding/events/cocktail.jpg": 838,
	"./wedding/events/wedding": 839,
	"./wedding/events/wedding.jpg": 839,
	"./wedding/thumb/11": 840,
	"./wedding/thumb/11.jpg": 840,
	"./wedding/thumb/15": 841,
	"./wedding/thumb/15.jpg": 841,
	"./wedding/thumb/19": 842,
	"./wedding/thumb/19.jpg": 842,
	"./wedding/thumb/20": 843,
	"./wedding/thumb/20.jpg": 843,
	"./wedding/thumb/21": 844,
	"./wedding/thumb/21.jpg": 844,
	"./wedding/thumb/22": 845,
	"./wedding/thumb/22.jpg": 845,
	"./wedding/thumb/23": 846,
	"./wedding/thumb/23.jpg": 846,
	"./wedding/thumb/24": 847,
	"./wedding/thumb/24.jpg": 847,
	"./wedding/thumb/25": 848,
	"./wedding/thumb/25.jpg": 848,
	"./wedding/thumb/26": 849,
	"./wedding/thumb/26.jpg": 849,
	"./wedding/thumb/27": 850,
	"./wedding/thumb/27.jpg": 850,
	"./wedding/thumb/28": 851,
	"./wedding/thumb/28.jpg": 851
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 896;